import { render, staticRenderFns } from "./NakedUser.vue?vue&type=template&id=c0a761c6&scoped=true"
import script from "./NakedUser.vue?vue&type=script&lang=js"
export * from "./NakedUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a761c6",
  null
  
)

export default component.exports